import { userStatus } from './UserStatus.helper';
import { envConfig } from './Config.helper';
import { EncryptMe } from './Crypto.helper';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const simpleFetchFn = async (method, headers, body, api, url) => {
  const user = userStatus();

  headers["Authorization"] = `Bearer ${user.bearer_token}`;
  headers["Content-Type"] = "application/json";
  headers["req-language"] = "pt_BR";

  let encrypted = await EncryptMe(body);

  let options = {
    mode: 'cors',
    method,
    headers,
    body: JSON.stringify(encrypted) || encrypted.length > 0 ? JSON.stringify(encrypted) : ''
  }

  if ( method === 'GET' ) delete options.body;

  const request = await fetch(`${envConfig[`${api.toUpperCase()}_API_URL`]}/${url}`, options);

  if ( request.status !== 200 ) return request.json();
  return await request.json();
}

const simpleFetchResponseFn = async (req, errMessage, successMessage) => {
  if ( req.status !== 200 ) {
    toast.error(errMessage, {
      position: toast.POSITION_TOP_RIGHT,
      className: 'toast-error'
    });

    return false;
  }

  toast.success(successMessage, {
    position: toast.POSITION_TOP_RIGHT,
    className: 'toast-success'
  });

  return true;
}

export { simpleFetchFn as simpleFetch }
export { simpleFetchFn as SimpleFetch };
export { simpleFetchResponseFn as SimpleFetchResponse };